import { AccessibilityFormComponent } from './accessibility-form/accessibility-form.component'
import { AddressPipe } from './pipes/address.pipe'
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { LOCALE_ID, NgModule } from '@angular/core'
import { AreaNamePipe } from './pipes/area-name.pipe'
import { AreaSelectionComponent } from './modal-booking-form/area-selection/area-selection.component'
import { BookingDetailsComponent } from './booking-details/booking-details.component'
import { BookingDetailsFormComponent } from './booking-details-form/booking-details-form.component'
import { BookingFeedbackComponent } from './booking-feedback/booking-feedback.component'
import {
    BookingFeedbackConfirmationComponent,
} from './booking-feedback-confirmation/booking-feedback-confirmation.component'
import {
    BookingFeedbackFormComponent,
} from './booking-feedback-form/booking-feedback-form.component'
import { BookingFormComponent } from './booking-form/booking-form.component'
import {
    BookingModalComponent,
} from './booking-modal/booking-modal.component'
import { BookingModalLauncherComponent } from './modal-launcher/booking-modal-launcher.component'
import { BookingPolicyStepComponent } from './booking-policy-step/booking-policy-step.component'
import { BookingReminderComponent } from './booking-reminder/booking-reminder.component'
import { BookingSlotComponent } from './booking-slot/booking-slot.component'
import {
    BookingSlotSelectionComponent,
} from './booking-slot-selection/booking-slot-selection.component'
import { BookingSummaryComponent } from './booking-summary/booking-summary.component'
import { BrowserModule } from '@angular/platform-browser'
import { CapitaliseOnBlurDirective } from './directives/capitalise-on-blur.directive'
import { CommaSplitPipe } from './pipes/comma-split.pipe'
import { ConfirmCancellationComponent } from './confirm-cancellation/confirm-cancellation.component'
import { ConfirmCardComponent } from './confirm-payment/confirm-card.component'
import { ConfirmationComponent } from './confirmation/confirmation.component'
import { ContextService } from './services/ContextService'
import { APP_BASE_HREF, CurrencyPipe, DatePipe, I18nPluralPipe, NgOptimizedImage, registerLocaleData } from '@angular/common'
import { CurrencyUnitPipe } from './pipes/currency-unit.pipe'
import { DayOfYearInputComponent } from './day-of-year-input/day-of-year-input.component'
import { DepositFormComponent } from './deposit-form/deposit-form.component'
import { BookingProductRefundPolicyComponent } from './landing-page/components/venue-storefront-booking-summary-card/booking-product-refund-policy.component'
import { DurationOptionsComponent } from './modal-booking-form/duration-options/duration-options.component'
import { DurationPipe } from './pipes/duration.pipe'
import { EnquiryFormComponent } from './enquiry-form/enquiry-form.component'
import { ErrorComponent } from './error/error.component'
import { EventNamePipe } from './pipes/event-name.pipe'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import gbLocale from '@angular/common/locales/en-GB'
import { LoadingComponent } from './loading/loading.component'
import { LandingPageHomeComponent } from './landing-page/components/home/home.component'
import { ModalBookingDetailsComponent } from './modal-booking-details/modal-booking-details.component'
import { ModalBookingFormComponent } from './modal-booking-form/modal-booking-form.component'
import { ModifyBookingComponent } from './modify-booking/modify-booking.component'
import { VenueStorefrontBookingSearchComponent } from './landing-page/components/venue-storefront-booking-search/venue-storefront-booking-search.component'
import { VenueStorefrontBookingSlotStepComponent } from './landing-page/components/venue-storefront-booking-slot-step/venue-storefront-booking-slot-step.component'
import { VenueStorefrontBookingSummaryCardComponent } from './landing-page/components/venue-storefront-booking-summary-card/venue-storefront-booking-summary-card.component'
import { MultipleChoiceInputComponent } from './multiple-choice-input/multiple-choice-input.component'
import { NgbDatePipe } from './pipes/ngb-date.pipe'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { NgbTimePipe } from './pipes/ngb-time.pipe'
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg'
import { NgxPaginationModule } from 'ngx-pagination'
import { NoAvailabilityComponent } from './no-availability/no-availability.component'
import { PaymentDetailsFormComponent } from './payment-details-form/payment-details-form.component'
import { RatingNamePipe } from './pipes/rating-name.pipe'
import { ReasonNamePipe } from './pipes/reason-name.pipe'
import { ReasonSelectionComponent } from './modal-booking-form/reason-selection/reason-selection.component'
import { ReasonTimePipe } from './pipes/reason-time.pipe'
import { RelativeDatePipe } from './pipes/relative-date.pipe'
import { RouterContextService } from './services/RouterContextService'
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators'
import { SpinnerOverlayComponent } from './spinner-overlay/spinner-overlay.component'
import { ThumborPipe } from './pipes/thumbor.pipe'
import { VenueColourDirective } from './directives/venue-colour.directive'
import { WithLoadingPipe } from './pipes/with-loading.pipe'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EventCardComponent } from './modal-booking-form/event-card/event-card.component';
import { EventBookingPageComponent } from './event-booking-page/event-booking-page.component'
import { SafeURLPipe } from './pipes/safe-url.pipe'
import { VoucherModalComponent } from './voucher-modal/voucher-modal.component';
import { VoucherModalLauncherComponent } from './modal-launcher/voucher-modal-launcher.component';
import { VoucherCheckoutComponent } from './voucher-checkout/voucher-checkout.component';
import { VoucherSelectionComponent } from './voucher-selection/voucher-selection.component';
import { VoucherPaymentConfirmationComponent } from './voucher-payment-confirmation/voucher-payment-confirmation.component'
import { ReasonCardComponent } from './modal-booking-form/reason-selection/reason-card/reason-card.component'
import { VoucherCardComponent } from './voucher-card/voucher-card.component'
import { RichTextModalComponent } from './rich-text-modal/rich-text-modal.component'
import { QuillModule } from 'ngx-quill'
import { WaitingForConfirmationComponent } from './waiting-for-confirmation/waiting-for-confirmation.component'
import { OrderSelectionComponent } from './order-selection/order-selection.component'
import { MenuChoicesEditComponent } from './menu-choices-edit/menu-choices-edit.component'
import { MenuViewComponent } from './menu-choices-edit/menu-view.component'
import { IndividualMenuChoicesComponent } from './individual-menu-choices/individual-menu-choices.component'
import { UniqueNameInputComponent } from './individual-menu-choices/unique-name-input.component'
import { MenuChoicesProgressComponent } from './menu-choices-progress/menu-choices-progress.component'
import { ToastsComponent } from './toast/toasts.component'
import { WaitlistFormComponent } from './waitlist-form/waitlist-form.component'
import { VenueNotInServiceComponent } from './venue-not-in-service/venue-not-in-service.component'
import {
    VoucherStorefrontComponent
} from './landing-page/components/voucher-storefront/voucher-storefront.component'
import {
    VenueStorefrontComponent
} from './landing-page/components/venue-storefront/venue-storefront.component'

registerLocaleData(gbLocale)

@NgModule({ declarations: [
    AccessibilityFormComponent,
    AppComponent,
    AreaNamePipe,
    AreaSelectionComponent,
    BookingDetailsFormComponent,
    BookingFeedbackComponent,
    BookingFeedbackConfirmationComponent,
    BookingFeedbackFormComponent,
    BookingFormComponent,
    BookingModalComponent,
    BookingModalLauncherComponent,
    BookingPolicyStepComponent,
    BookingReminderComponent,
    BookingSlotComponent,
    BookingSlotSelectionComponent,
    BookingSummaryComponent,
    CommaSplitPipe,
    ConfirmCancellationComponent,
    ConfirmCardComponent,
    DayOfYearInputComponent,
    DepositFormComponent,
    DurationOptionsComponent,
    DurationPipe,
    DurationPipe,
    ErrorComponent,
    EventNamePipe,
    LoadingComponent,
    LandingPageHomeComponent,
    ModalBookingDetailsComponent,
    ModalBookingDetailsComponent,
    ModalBookingFormComponent,
    ModifyBookingComponent,
    NgbDatePipe,
    NgbTimePipe,
    NoAvailabilityComponent,
    PaymentDetailsFormComponent,
    RatingNamePipe,
    ReasonNamePipe,
    ReasonSelectionComponent,
    RelativeDatePipe,
    SpinnerOverlayComponent,
    ThumborPipe,
    WithLoadingPipe,
    EventCardComponent,
    EventBookingPageComponent,
    SafeURLPipe,
    VoucherCardComponent,
    VoucherModalComponent,
    VoucherModalLauncherComponent,
    VoucherCheckoutComponent,
    VoucherSelectionComponent,
    VoucherPaymentConfirmationComponent,
    ReasonCardComponent,
    RichTextModalComponent,
    WaitingForConfirmationComponent,
    OrderSelectionComponent,
    MenuChoicesEditComponent,
    MenuViewComponent,
    IndividualMenuChoicesComponent,
    UniqueNameInputComponent,
    ToastsComponent,
    VenueNotInServiceComponent,
    VoucherStorefrontComponent,
],
bootstrap: [AppComponent],
exports: [
    CurrencyUnitPipe,
    LoadingComponent,
    NgbDatePipe,
    RatingNamePipe,
],
    imports: [
        AppRoutingModule,
        AddressPipe,
        BookingDetailsComponent,
        BookingProductRefundPolicyComponent,
        BrowserModule,
        CapitaliseOnBlurDirective,
        ConfirmationComponent,
        CurrencyUnitPipe,
        EnquiryFormComponent,
        FormsModule,
        MenuChoicesProgressComponent,
        MultipleChoiceInputComponent,
        NgbModule,
        NgOptimizedImage,
        NgxIntlTelInputModule,
        NgxPaginationModule,
        QuillModule.forRoot(),
        ReactiveFormsModule,
        ReasonTimePipe,
        RxReactiveFormsModule,
        VenueColourDirective,
        VenueStorefrontComponent,
        VenueStorefrontBookingSearchComponent,
        VenueStorefrontBookingSlotStepComponent,
        VenueStorefrontBookingSummaryCardComponent,
        WaitlistFormComponent,
    ],
providers: [
    {
        provide: ContextService,
        useClass: RouterContextService,
    },
    {
        provide: LOCALE_ID,
        useValue: 'en-GB',
    },
    {
        provide: APP_BASE_HREF,
        useValue: '/',
    },
    CurrencyPipe,
    DatePipe,
    DurationPipe,
    I18nPluralPipe,
    NgbDatePipe,
    NgbTimePipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
] })
export class AppModule {

    constructor() { }
}
